import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'// 官网首页
import News from '../views/News.vue'// 新闻列表页
import New from '../views/New.vue'// 新闻详情页
import Product from '../views/Product.vue'// 产品页
import About from '../views/About.vue'// 关于我们页
import Contact from '../views/Contact.vue'// 联系我们页
import Auth from '../views/Auth.vue'// 客户登录/注册页
import OrderSubmit from '../views/OrderSubmit.vue'// 客户自助提交订单页
import MyOrders from '../views/MyOrders.vue'// 我的订单页

import NProgress from 'nprogress'// 进度调样式模块
import 'nprogress/nprogress.css'
const routes = [
  {// 首页
    path: '/',
    name: 'home',
    component: Home
  },
  {// 新闻列表页
    path: '/news',
    name: 'news',
    component: News
  },
  {// 新闻详情页
    path: '/news/:id',
    name: 'new',
    component: New
  },
  {// 产品页
    path: '/product',
    name: 'product',
    component: Product
  },
  {// 关于我们
    path: '/about',
    name: 'about',
    component: About
  },
  {// 联系我们
    path: '/contact',
    name: 'contact',
    component: Contact
  },
  {// 客户登录/注册
    path: '/auth',
    name: 'auth',
    component: Auth
  },
  {// 客户自助提交订单
    path: '/order-submit',
    name: 'order-submit',
    component: OrderSubmit
  },
  {// 我的订单
    path: '/my-orders',
    name: 'my-orders',
    component: MyOrders
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      try {
        const el = document.querySelector(to.hash)
        if (el && el.parentNode) {
          return { el: to.hash, behavior: 'smooth' }
        }
      } catch (e) {
        // ignore
      }
    }
    return { top: 0 }
  }
})


router.beforeEach((to, from, next) => {
  NProgress.start();
  next()
})

router.afterEach((to, from) => {
  NProgress.done();
  // 只记录 SPA 客户端导航，初始页面加载由服务器中间件记录
  if (from.name !== null) {
    fetch('/webapi/visit/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: to.path })
    }).catch(() => {})
  }
})


export default router
